import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import './Navbar.css';

const Navbar = ({ theme, toggleTheme }) => {
  const { user, logout } = useContext(AuthContext);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isMenuOpen]);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  const closeMenu = () => setIsMenuOpen(false);
  const toggleMenu = () => setIsMenuOpen(v => !v);

  const isActive = (path) => location.pathname === path;

  const primaryLinks = [
    { to: '/', label: 'Home' },
    { to: '/about', label: 'About' },
    { to: '/contact-us', label: 'Contact' },
  ];

  return (
    <>
      <nav className="navbar" aria-label="Primary">
        <div className="navbar-container">
          <Link to="/" className="navbar-brand" onClick={closeMenu}>
            <img
              src="/SkyscopeAviation.png"
              alt=""
              className="navbar-logo"
              aria-hidden="true"
            />
            <span className="navbar-wordmark">
              <em>Sky</em>Scope Aviation
            </span>
          </Link>

          <ul className="navbar-links">
            {primaryLinks.map(l => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className={`navbar-link ${isActive(l.to) ? 'is-active' : ''}`}
                >
                  {l.label}
                </Link>
              </li>
            ))}

            {user && (
              <>
                <li>
                  <Link
                    to="/create-blog"
                    className={`navbar-link ${isActive('/create-blog') ? 'is-active' : ''}`}
                  >
                    Create
                  </Link>
                </li>
                <li>
                  <Link
                    to="/my-blogs"
                    className={`navbar-link ${isActive('/my-blogs') ? 'is-active' : ''}`}
                  >
                    My Posts
                  </Link>
                </li>
                {user.role === 'admin' && (
                  <li>
                    <Link
                      to="/admin"
                      className={`navbar-link navbar-link-admin ${isActive('/admin') ? 'is-active' : ''}`}
                    >
                      Admin
                    </Link>
                  </li>
                )}
              </>
            )}
          </ul>

          <div className="navbar-right">
            <button
              onClick={toggleTheme}
              className="theme-toggle"
              aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
              title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
            >
              {theme === 'dark' ? 'LT' : 'DK'}
            </button>

            {user ? (
              <button onClick={logout} className="navbar-cta" aria-label="Sign out">
                Sign out
              </button>
            ) : (
              <Link to="/signin" className="navbar-cta">
                Sign in
              </Link>
            )}

            <button
              className={`burger-menu ${isMenuOpen ? 'is-open' : ''}`}
              onClick={toggleMenu}
              aria-label="Toggle menu"
              aria-expanded={isMenuOpen}
            >
              <span className="burger-line" aria-hidden="true" />
              <span className="burger-line" aria-hidden="true" />
              <span className="burger-line" aria-hidden="true" />
            </button>
          </div>
        </div>
      </nav>

      <div
        className={`mobile-drawer ${isMenuOpen ? 'is-open' : ''}`}
        aria-hidden={!isMenuOpen}
      >
        <ul className="mobile-drawer-links">
          {primaryLinks.map(l => (
            <li key={l.to}>
              <Link
                to={l.to}
                className={`mobile-drawer-link ${isActive(l.to) ? 'is-active' : ''}`}
                onClick={closeMenu}
              >
                {l.label}
              </Link>
            </li>
          ))}
          {user && (
            <>
              <li>
                <Link
                  to="/create-blog"
                  className={`mobile-drawer-link ${isActive('/create-blog') ? 'is-active' : ''}`}
                  onClick={closeMenu}
                >
                  Create
                </Link>
              </li>
              <li>
                <Link
                  to="/my-blogs"
                  className={`mobile-drawer-link ${isActive('/my-blogs') ? 'is-active' : ''}`}
                  onClick={closeMenu}
                >
                  My Posts
                </Link>
              </li>
              {user.role === 'admin' && (
                <li>
                  <Link
                    to="/admin"
                    className={`mobile-drawer-link mobile-drawer-link-admin ${isActive('/admin') ? 'is-active' : ''}`}
                    onClick={closeMenu}
                  >
                    Admin
                  </Link>
                </li>
              )}
            </>
          )}
        </ul>

        <div className="mobile-drawer-footer">
          {user ? (
            <>
              <span className="mobile-drawer-user">
                {user.name}
              </span>
              <button
                onClick={() => { logout(); closeMenu(); }}
                className="mobile-drawer-cta"
              >
                Sign out
              </button>
            </>
          ) : (
            <Link
              to="/signin"
              className="mobile-drawer-cta"
              onClick={closeMenu}
            >
              Sign in
            </Link>
          )}
        </div>
      </div>
    </>
  );
};

export default Navbar;
